module.exports = {"select_gender":"Wähle dein Geschlecht","male":"Männlich","female":"Weiblich"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/gender.json
// module id = 488
// module chunks = 248 1689